import React, {Component,useState,useEffect} from 'react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import  logo from '../../assets/img/logo.png';
import GetPagesData from "../Routes";
import { trans } from "../utils";
import config from '../../config.js';
const Login = () => {
    const SystemUrl = config.SystemUrl;
    const [userRequest, setUserRequest] = useState({
        email: '',
        password: '',
        isLoading: false,
        errorEmail : '',
        errorPassword: '',
        location: {},
        invalidEmail : false
    });
    let ClientLogo=localStorage.getItem('ClientLogo');
    let SystemTitle=localStorage.getItem('SystemTitle')?localStorage.getItem('SystemTitle') : "HIC - AEON";

    useEffect(() => {
        document.title = SystemTitle;

    },[userRequest]);

    const renderRedirect = () => {
        if (userRequest.redirect==true && userRequest.location) {
            // If a last route is provided, redirect to that route
            window.location.href = userRequest.location;
        } else if (userRequest.redirect==true) {
            // Otherwise, reload the current page
            window.location.reload(true);
        }
    };
    const isLoading = userRequest.isLoading;

    const handleEmailChange = event => {
        console.log("handleEmailChange")

        setUserRequest({...userRequest,email: event.target.value} );
    };
    const handlePwdChange = event => {
        setUserRequest({...userRequest,password: event.target.value} );
    };
    const handleSubmit = event => {
        event.preventDefault();

        const Sanctumurl = SystemUrl+'sanctum/csrf-cookie';
        axios.get(Sanctumurl).then(response => {
            setUserRequest({...userRequest,isLoading: true} );
            const url = SystemUrl+'login';
            const email = userRequest.email;
            const password = userRequest.password;
            let bodyFormData = new FormData();
            bodyFormData.set('email', email);
            bodyFormData.set('password', password);
            axios.post(url, bodyFormData)
                .then(result => {
                    var pages=result.data.data.pages;
                    localStorage.setItem('isLoggedIn', true)
                    localStorage.setItem('userRole', result.data.data.user.role)
                    //Refresh Routes
                    GetPagesData(pages);
                    setUserRequest({...userRequest,redirect: true, isLoading: false, location: result.data.data.user.last_route} );
                    renderRedirect();
                })
                .catch(async (error) => {
                    if( error.response ){
                        setUserRequest({...userRequest,errorEmail :error.response.data.errors.hasOwnProperty('email')? error.response.data.errors.email[0]:"",errorPassword : error.response.data.errors.hasOwnProperty('password')?error.response.data.errors.password[0]:"",isLoading: false});
                    }

                });
        });


    };


    return (

        <div className="d-flex flex-column flex-root bg-temp">
             {/*// style={{ backgroundImage: `url(${background})` }}>*/}

            <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed bg-login">
                <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">

                    <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
                        <div className="row">
                            <div className="col-md-6 text-center">
                                <img alt="Logo" src={logo} className="h-60px m-2"/>
                            </div>
                            <div className="col-md-6 text-center">
                                <img alt="ClientLogo" src={ClientLogo} className="h-60px m-2"/>
                            </div>

                        </div>

                        <form className="form w-100 mt-10" noValidate="novalidate" id="kt_sign_in_form" action="#"
                              onSubmit={handleSubmit}>

                            {/*<div className="text-center mb-10">*/}

                            {/*    <h1 className="text-dark mb-3">{trans('Welcome to AEON')}</h1>*/}
                            {/*</div>*/}

                            <div className="fv-row mb-10">

                                <label className="form-label fs-6 fw-bolder text-dark">{trans('Email')}</label>
                                <input
                                    className="form-control form-control-lg form-control-solid"
                                    id="inputEmail" placeholder={trans('Email address')} type="text" name="email"
                                    onChange={handleEmailChange} autoFocus required />

                                { userRequest.errorEmail &&
                                <div className="fv-plugins-message-container text-danger">
                                    <div data-field="email" data-validator="emailAddress">{ userRequest.errorEmail } </div>
                                </div> }


                            </div>

                            <div className="fv-row mb-10">

                                <div className="d-flex flex-stack mb-2">

                                    <label className="form-label fw-bolder text-dark fs-6 mb-0">{trans('Password')}</label>
                                    <a href="/forget-password"
                                       className="link-primary fs-6 fw-bolder">Forgot Password ?</a>

                                </div>
                                <input type="password"
                                       className="form-control form-control-lg form-control-solid"
                                       id="inputPassword" placeholder={trans('Enter Your Password')} name="password"
                                       onChange={handlePwdChange} required/>
                                { userRequest.errorPassword &&
                                <div className="fv-plugins-message-container text-danger">
                                    <div data-field="email" data-validator="emailAddress">{ userRequest.errorPassword } </div>
                                </div> }

                            </div>

                            <div className="text-center">

                                <button className="btn btn-light-primary font-weight-bold mr-2" type="submit" disabled={userRequest.isLoading ? true : false}> <span className="indicator-label">{trans('Login')} </span>

                                    {isLoading ? (
                                         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <span></span>
                                    )}
                                </button>

                            </div>

                        </form>


                    </div>

                </div>

            </div>
            {renderRedirect()}
        </div>
    );


}
export default  Login;